var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenericCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 455,
    height: 312,
    viewBox: "0 0 455 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M10.08 0H334.8c5.567 0 10.08 4.513 10.08 10.08v180c0 5.567-4.513 10.08-10.08 10.08H10.08C4.513 200.16 0 195.647 0 190.08v-180C0 4.513 4.513 0 10.08 0z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "150.2%",
    height: "186.4%",
    x: "-25.1%",
    y: "-40.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 28
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.21446132 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 51)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#17A141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.583 77.534h10.842v10.878h-10.842zM358.522 77.534h10.841v10.878h-10.84zM357.869 105.463h11.623v11.776h-11.623zM343.018 105.463h10.977v11.776h-10.977zM327.52 105.463h11.623v11.776H327.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.099 77.127l-.001 14.352h28.265l.005 10.67h-28.27v.002H327.16V77.127h13.939z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#999",
    transform: "translate(81.64 190.68)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.96,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.143,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.326,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.509,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.44,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.623,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.806,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.989,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.92,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.103,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.286,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.469,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.4,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.583,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.766,
    cy: 3.96,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.949,
    cy: 3.96,
    r: 3.96
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericCard);
export default __webpack_public_path__ + "static/media/generic-card.5d0ac5d1.svg";
export { ForwardRef as ReactComponent };